module.exports = __webpack_public_path__ + "static/media/05-München@2x.2a2508e4.jpg";